import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link: string;
  submenu?: MenuItem[];
}

const menus: MenuItem[] = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    title: "Products",
    link: "#",
    submenu: [
      { id: 21, title: "Face Engine", link: "/service-details" },
      { id: 22, title: "Watchlist Screening", link: "/service-details" },
      { id: 23, title: "Bank Statement Analyzer", link: "/service-details" },
      { id: 24, title: "Legal Opinion", link: "/service-details" },
      { id: 25, title: "Credit Approval Engine", link: "/service-details" },
    ],
  },
  {
    id: 3,
    title: "Solutions",
    link: "#",
    submenu: [
      { id: 31, title: "Fintech & Lending", link: "/about" },
      { id: 32, title: "Banking & Insurance", link: "/about" },
      { id: 33, title: "Telco & Marketplace", link: "/about" },
      { id: 34, title: "Government & Healthcare", link: "/about" },
    ],
  },
  {
    id: 4,
    title: "About Us",
    link: "/about",
  },
  {
    id: 5,
    title: "Blog",
    link: "/blog",
  },
  {
    id: 6,
    title: "Contact",
    link: "/contact",
  },
];

const MobileMenu: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Fragment>
      <ul>
        {menus.map((item) => (
          <li
            key={item.id}
            className={item.submenu ? "menu-item-has-children" : ""}
          >
            {item.submenu ? (
              <>
                <span
                  onClick={() => handleToggle(item.id)}
                  className="xb-menu-toggle"
                >
                  {item.title}
                  <i
                    className={`fas fa-chevron-${
                      openId === item.id ? "up" : "down"
                    }`}
                    style={{ marginLeft: "8px", fontSize: "12px" }}
                  ></i>
                </span>
                <Collapse in={openId === item.id}>
                  <ul className="submenu">
                    {item.submenu.map((sub) => (
                      <li key={sub.id}>
                        <Link to={sub.link} onClick={handleClick}>
                          {sub.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Collapse>
              </>
            ) : (
              <Link to={item.link} onClick={handleClick}>
                {item.title}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default MobileMenu;
